import React from 'react';
import BaseRowView from '../..';
import "./styles.css";
import { SVGAsset } from 'res';

/**
 * @function ControlView
 * @param {STRING} controlText - The control name is passed to the mainText of the BaseRowView.
 * @param {STRING} controlSubText - The description of the options in the control is passed to the subText of the BaseRowView.
 * @param {STRING} leftIcon - The SVGAsset of the control icon is passed to the BaseRowView as the leftIcon.
 * @param {STRING} className - Additional classes to add to the ControlView.
 * @return {React.Component}
 * @exported true
 * @description This is built using the BaseRowView as the base component. 
 * This shows and icon to the left corresponding to the option.
 * @example
 * <ControlView className="addedClass" leftIcon="storeIcon" controlText="Merchant Types" controlSubText="Department Store, Entertainment" />
 */
export default function ControlView(props) {
  const controlSubText = props.controlSubText ?? "";
  const controlText = props.controlText ?? "";
  const leftIcon = props.leftIcon !== undefined ? (<SVGAsset id={props.leftIcon} className="set-width left-icon align-center-item" />) : (<></>);
  const className = props.className ?? "";
  const dataPoint = props.dataPoint;
  return (
    <div className={className + " control-view"}>
      <BaseRowView leftIcon={leftIcon} mainText={ controlText } subText={ controlSubText } onClick={props.onClick} dataPoint={dataPoint}/>
    </div>
  );
}